import { Routes } from "@angular/router";

import { blockDaysManagementRoutes, blockDaysRoutes } from "./block-days";

import { myTicketsRoutes } from "src/app/features/my-tickets";
import { soldProductsRoutes } from "./products";

const myReservationsBaseRoute = myTicketsRoutes[0];
const myReservationsDetails = myTicketsRoutes[1];

export const reservationsRoutes: Routes = [
  {
    path: "",
    title: "TICKETS.RESERVATIONS",
    data: {
      tabs: [
        {
          key: "services",
          title: "BLOCK_DAYS.ALL",
          routerLink: "/admin/reservations",
        },
        {
          key: "block-days",
          title: "BLOCK_DAYS.TITLE",
          routerLink: "block-days",
        },
        {
          key: "products",
          title: "PRODUCTS.TITLE",
          routerLink: "sold-products",
        },
      ],
    },
    loadComponent: () =>
      import("src/app/shared/base-components/base-tabs-management/base-tabs-management.component").then(
        (c) => c.BaseTabsManagementComponent,
      ),
    children: [
      myReservationsBaseRoute,
      {
        path: "block-days",
        children: blockDaysRoutes,
      },
      {
        path: "sold-products",
        children: soldProductsRoutes,
      },
    ],
  },
  {
    path: "view",
    children: [myReservationsDetails],
  },
  {
    path: "block-days",
    children: blockDaysManagementRoutes,
  },
];
